module.exports = __webpack_public_path__ + "img/googleIcon.3e67f262.png";